<template>
  <div class="toQueryBig" style="background: #f4f4f4">
    <div
      style="
        height: 0.92rem;
        text-align: center;
        line-height: 0.9rem;
        font-size: 0.3rem;
        overflow: hidden;
    position: relative;
      "
    >
      <!-- <van-icon name="arrow-left" @click="home" id="btnLeft" style="width: 5%; text-align: left" /> -->
      <van-search
        style="width: 85%; display: inline-block"
        v-model="name"
        class="btnCenter"
        shape="round"
        background="#f4f4f4"
        placeholder="输入手机号或身份证号"
      />
      <div
        style="display: inline-block; text-align: right; background: #f4f4f4"
        @click="btn"
        id="btnRight"
      >
        搜索
      </div>
    </div>
    <div class="main" style="background: #fff"  v-show="isShow" >
      <p>
        <a class="titleDiv">姓名</a>
        <input
          class="inputs"
          type="text"
          v-model.trim="form.name"
          disabled
        />
      </p>
      <p>
        <a class="titleDiv">手机号</a>
        <input
          class="inputs"
          type="text"
          v-model.trim="form.phone"
          disabled
        />
      </p>
      <p>
        <a class="titleDiv">身份证号</a>
        <input
          class="inputs"
          type="text"
          v-model.trim="form.idCard"
          disabled
        />
      </p>
      <p>
        <a class="titleDiv">行业类别</a> 
        <select class="selectChecd" v-model="form.industryType" disabled  >
          <option  disabled value="99999">---</option>
          <option  disabled   v-for="(item, index) in industryTypeOption" :key="index" :value="item.id">{{ item.name }}</option>
        </select>
      </p>
       <p v-if="form.isEnroll == '未报名' || form.isEnroll == '---'">
        <a class="titleDiv">是否报名</a>
        <input
        v-if="form.isEnroll== '已报名'"
        style="color: #00ae7e;"
          class="inputs"
          type="text"
          v-model.trim="form.isEnroll"
          disabled
        />
         <input
         v-if="form.isEnroll== '未报名'"
         style="color: #fa533d;"
          class="inputs"
          type="text"
          v-model.trim="form.isEnroll"
          disabled
        />
         <input
         v-if="form.isEnroll== '---'"
          class="inputs"
          type="text"
          v-model.trim="form.isEnroll"
          disabled
        />
      </p>
       <p  v-if="form.isEnroll == '已报名'">
        <a class="titleDiv">培训状态</a>
        <div v-for="(item,index) in form.studyList" :key="index">
           <p v-if="item.status == '已完成'" style="color: #00ae7e;">
                {{ item.year }}：{{ item.status }}
           </p>
           <p v-if="item.status == '学习中'" style="color: #fa533d;">
                {{ item.year }}：{{ item.status }}
           </p>
           <p v-if="item.status == '未学习'" style="color: #fa533d;">
                {{ item.year }}：{{ item.status }}
           </p>
       </div>
      </p>
    </div>
    <div class="btnDiv" v-show="isShow">
       <div class="btn" @click="goSignUp">去报名</div>
      <div class="btn" @click="home">回首页</div>
     
      <!-- <div class="determineBtn">确定</div> -->
    </div>
  </div>
</template>

<script>
import { Icon, Search, Field, CellGroup } from "vant";
import request from "@/utils/request";

export default {
  components: {
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      isShow: false,
      name: "",
      form: {
        name: "",
      },
      industryTypeOption: [],
    };
  },
  created() {
    this.listForIndustryType();
  },
  methods: {
    listForIndustryType() {
      let _this = this;
      let urls = Global.env + Global.apiCore.listForIndustryType;
      return new Promise((resolve, reject) => {
        request({
          url: urls,
          method: "post",
        })
          .then((response) => {
            this.industryTypeOption = response.data;
          })
          .catch((error) => {});
      });
    },

    home() {
      this.$router.push({
        name: "Registration",
        query: {},
      });
    },
    goSignUp() {
      this.$router.push({
        name: "RegistrationPage",
        query: {},
      });
    },
    btn() {
      let _this = this;
      let urls = Global.env + Global.apiCore.query;
      return new Promise((resolve, reject) => {
        request({
          url: urls,
          method: "post",
          data: {
            name: _this.name,
          },
        })
          .then((response) => {
            if (response.resultCode == "1000") {
              this.form = response.data;
              this.form.industryType = Number(response.data.industryType);
              if (this.form.isEnroll == 1) {
                this.form.isEnroll = "已报名";
              } else if (this.form.isEnroll == 0) {
                this.form.isEnroll = "未报名";
              } else {
                this.form.isEnroll = "---";
              }
              if (this.form.status == 1) {
                this.form.status = "已学习";
              } else if (this.form.status == 0) {
                this.form.status = "未学习";
              } else {
                this.form.status = "---";
              }
              if (this.form.name == null || this.form.name == "") {
                this.form.name = "---";
              }
              if (this.form.phone == null || this.form.phone == "") {
                this.form.phone = "---";
              }
              if (this.form.idCard == null || this.form.idCard == "") {
                this.form.idCard = "---";
              }
               if (this.form.industryType == null || this.form.industryType == "") {
                this.form.industryType = 99999;
              }
              this.isShow = true;
            }
          })
          .catch((error) => {
            // Dialog.alert({
            // 	message: error.errmsg
            // }).then(() => {
            // 	// on close
            // });
            // return reject(error);
          });
      });
    },
  },
};
</script>

<style  scoped>
#btnLeft {
  position: absolute;
  left: 0.1rem;
  top: 50%;
  transform: translate(0, -50%);
}
.btnCenter {
  width: 85%;
  display: inline-block;
  background: rgb(244, 244, 244);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#btnRight {
  display: block;
  position: absolute;
  right: 0.1rem;
  top: 50%;
  transform: translate(0, -50%);
}
.toQueryBig {
  background: #f4f4f4;
  height: 100%;
  display: block;
}
.selectChecd {
  width: 100%;
  /* border: none;
	background: none;
	background: #f8f8f8;
	border: 1px solid #eee;
	font-size: 0.28rem; */
  height: 0.78rem;
  border: none;
  /* outline: none;  */
  height: 40px;
  line-height: 40px;
  /* appearance: none; */
  /* background: none; */
  /* -webkit-appearance: none; */
  font-size: 0.28rem;
  border: 1px solid #eee;
  /* -moz-appearance:none; */
  background: #f8f8f8;
}
.registrationBig {
  overflow: hidden;
  height: 100%;
}
.headerDiv {
  position: relative;
  height: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  font-size: 0.26rem;
  border-bottom: 1px solid #eeeeee;
}
.fh {
  position: absolute;
  left: 0.1rem;
  top: 50%;
  transform: translate(0, -50%);
}
.main {
  width: 100%;
  margin: 0 auto;
  font-size: 0.3rem;
  line-height: 0.52rem;
  font-weight: 400;
  background: #fff;
  padding: 3% 7%;
  /* margin-top: 0.2rem; */
  margin-bottom: 0.3rem;
}
.determineBtn {
  width: 100%;
  height: 0.82rem;
  line-height: 0.82rem;
  background: #00ae7e;
  border-radius: 4px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  float: left;
  color: rgba(255, 255, 255, 1);
  font-size: 0.3rem;
}
/* .btn {
  width: 50%;
  height: 0.82rem;
  background: #00ae7e;
  border-radius: 4px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  float: left;
  color: rgba(255, 255, 255, 1);
  font-size: 0.3rem;
} */
.btn {
  width: 94%;
  height: 0.82rem;
  line-height: 0.82rem;
  background: #00ae7e;
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 0.15rem;
  text-align: center;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  font-size: 0.3rem;
}
.btnDev {
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 0;
}
.main .titleDiv {
  display: block;
  color: #333;
  font-size: 0.36rem;
  margin: 0.14rem 0;
}
.main .inputs {
  width: 100%;
  border: none;
  background: #f8f8f8;
  border: 1px solid #eeeeee;
  padding-left: 0.1rem;
  font-size: 0.28rem;
  height: 0.78rem;
}
.tips {
  line-height: 0.8rem;
  font-size: 0.3rem;
  font-weight: 800;
  text-align: center;
}
.tipsSuccess {
  line-height: 0.8rem;
  font-size: 0.3rem;
  font-weight: 800;
  text-align: center;
  color: #fa533d;
}
.tipsFail {
  font-size: 0.3rem;
  font-weight: 800;
  text-align: center;
  color: #fa533d;
  padding: 0.2rem 0;
}
</style>
